import CodeBase from "./CodeBase.js"

// 시나리오 답변유형별 액션 코드

class ScenarioAnswerActionCode extends CodeBase {
  constructor() {
    const CODE_MAP = {
      'A01' : '대화종료',
      'A02' : '반복질문(1회)',
      'A03' : '반복질문(2회)',
      'A04' : '2차질문',
      'A05' : '의도복귀',
      'A06' : '통화독려(1회)'
    };

    super(CODE_MAP);
  }
}

export default ScenarioAnswerActionCode;
